/**
 * Kody ustawień publicznych
 *
 * @export
 * @enum {number}
 */
export enum PublicSettings {
  ARCHIVE_STATUSES = 'ARCHIVE_STATUSES',
  ATTACHMENTS_SHOW_RADIO = 'ATTACHMENTS_SHOW_RADIO',
  CHILD_PROCEDURE_ID = 'CHILD_PROCEDURE_ID',
  COLUMNS = 'COLUMNS',
  DECISION_DATA_DATES_DICTIONARY = 'DECISION_DATA_DATES_DICTIONARY',
  DECISION_REPORT_COLUMNS = 'DECISION_REPORT_COLUMNS',
  DECISION_WITH_RANGES = 'DECISION_WITH_RANGES',
  DISABLE_MDOK_IMPORT_EXTRA_FIELDS = 'DISABLE_MDOK_IMPORT_EXTRA_FIELDS',
  DOCUMENT_ATTACHMENT_VIEW_IDS = 'DOCUMENT_ATTACHMENT_VIEW_IDS',
  DOCUMENT_RENDER_OPTIONS = 'DOCUMENT_RENDER_OPTIONS',
  DOCUMENT_VIEW_ID = 'DOCUMENT_VIEW_ID',
  FILE_LIMITS = 'FILE_LIMITS',
  FILTERS = 'FILTERS',
  FINANCIAL_PLAN_COLUMNS = 'FINANCIAL_PLAN_COLUMNS',
  FINANCIAL_REPORT_AVAILABLE_FILTERS = 'FINANCIAL_REPORT_AVAILABLE_FILTERS',
  FINANCIAL_REPORT_COLUMNS = 'FINANCIAL_REPORT_COLUMNS',
  GDPR_INFO_CLAUSE = 'GDPR_INFO_CLAUSE',
  GDPR_POLICY = 'GDPR_POLICY',
  HARDCODED_REPORTS = 'HARDCODED_REPORTS',
  HIDE_DOCUMENT_DOCUMENTATION_FOR_JO = 'HIDE_DOCUMENT_DOCUMENTATION_FOR_JO',
  HIDE_DOCUMENT_GENERATE_FOR_JO = 'HIDE_DOCUMENT_GENERATE_FOR_JO',
  HIDE_GENERAL_REPORT = 'HIDE_GENERAL_REPORT',
  HIDE_JO_SYSTEM_NUMBERS = 'HIDE_JO_SYSTEM_NUMBERS',
  HIDE_PROCEDURE_DOCUMENTATION = 'HIDE_PROCEDURE_DOCUMENTATION',
  HIDE_PROCEDURE_DOCUMENTATION_FOR_JO = 'HIDE_PROCEDURE_DOCUMENTATION_FOR_JO',
  HIDE_PROCEDURE_GENERATE_FOR_JO = 'HIDE_PROCEDURE_GENERATE_FOR_JO',
  HIDE_PROCEDURE_PAYMENTS = 'HIDE_PROCEDURE_PAYMENTS',
  IGNORE_CRITERIONS_FOR_COLOR = 'IGNORE_CRITERIONS_FOR_COLOR',
  KSAT_DISABLED = 'KSAT_DISABLED',
  OLD_STRUCTURE_NODE_MAPPING = 'OLD_STRUCTURE_NODE_MAPPING',
  OW_003_MAX_AMOUNT = 'OW_003_MAX_AMOUNT',
  OW_003_RANGES = 'OW_003_RANGES',
  OW_004_DE_MINIMIS_MAX = 'OW_004_DE_MINIMIS_MAX',
  PACK_CREATE_SHOW = 'PACK_CREATE_SHOW',
  PACK_ENABLED = 'PACK_ENABLED',
  PAYMENT_COLUMNS = 'PAYMENT_COLUMNS',
  PAYMENT_LIST_CONFIG = 'PAYMENT_LIST_CONFIG',
  PAYMENT_LIST_TYPES = 'PAYMENT_LIST_TYPES',
  PAYMENT_NO_SPLIT = 'PAYMENT_NO_SPLIT',
  PAYMENT_PACK_COLUMNS = 'PAYMENT_PACK_COLUMNS',
  PAYMENT_PACK_DETAILS_COLUMNS = 'PAYMENT_PACK_DETAILS_COLUMNS',
  PROCEDURE_ATTACHMENT_COLUMN_NAME = 'PROCEDURE_ATTACHMENT_COLUMN_NAME',
  PROCEDURE_ATTACHMENT_SUBDOCUMENT_NAME = 'PROCEDURE_ATTACHMENT_SUBDOCUMENT_NAME',
  PROCEDURE_DOCUMENT_DETAILS_BREADCRUMB = 'PROCEDURE_DOCUMENT_DETAILS_BREADCRUMB',
  PROCEDURE_DOCUMENT_EDIT_BREADCRUMB = 'PROCEDURE_DOCUMENT_EDIT_BREADCRUMB',
  PROCEDURE_EDITABLE_DOCUMENT_VALUE_CODES = 'PROCEDURE_EDITABLE_DOCUMENT_VALUE_CODES',
  PROCEDURE_GET_PDF_BUTTON_TEXT = 'PROCEDURE_GET_PDF_BUTTON_TEXT',
  PROCEDURE_PUBLIC_VALUES = 'PROCEDURE_PUBLIC_VALUES',
  PROCEDURE_TABLE_BUTTONS = 'PROCEDURE_TABLE_BUTTONS',
  PROCEDURE_TABS = 'PROCEDURE_TABS',
  PROCEDURE_VIEW_IDS = 'PROCEDURE_VIEW_IDS',
  PROCEDURE_WITHOUT_INFO = 'PROCEDURE_WITHOUT_INFO',
  RENDER_EMPTY_OPTIONS = 'RENDER_EMPTY_OPTIONS',
  RENDER_VIEW_OPTIONS = 'RENDER_VIEW_OPTIONS',
  REPORT_COLUMNS = 'REPORT_COLUMNS',
  REPORT_FILTERS = 'REPORT_FILTERS',
  REPORT_GROUPS = 'REPORT_GROUPS',
  SCHOOL_YEAR = 'SCHOOL_YEAR',
  SEPARATE_SCHOOLS_DISPLAY = 'SEPARATE_SCHOOLS_DISPLAY',
  SIDE_MENU = 'SIDE_MENU',
  STATISTICS_COLUMNS = 'STATISTICS_COLUMNS',
  SUBMIT_BUTTON_TEXT = 'SUBMIT_BUTTON_TEXT',
  SUBMITTED_MANUALLY_TEXT = 'SUBMITTED_MANUALLY_TEXT',
  SYSTEM_MESSAGE_ENTITY_ROUTE_QUERY = 'SYSTEM_MESSAGE_ENTITY_ROUTE_QUERY'
}
